<!-- Overlay loading -->
<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                userId
                  ? ("editUser" | translate)
                  : ("createNewUser" | translate)
              }}</span>
            </h3>
          </div>
          <div class="card-body py-3">
            <form [formGroup]="userForm" (ngSubmit)="saveUser($event)">
              <div class="row mb-5 mt-5">
                <!-- Role -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="roleId"
                      class="form-select cursor-pointer"
                      id="inputRole"
                      aria-label="Role"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectARole" | translate }}
                      </option>
                      <option *ngFor="let role of roles" [value]="role.id">
                        {{ role.name }}
                      </option>
                    </select>
                    <label for="inputRole">{{ "role" | translate }}</label>
                    <div *ngIf="isControlInvalid('roleId')" class="text-danger">
                      {{ "selectRole" | translate }}
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="branchCode"
                      class="form-select cursor-pointer"
                      id="inputBranch"
                      aria-label="Branch"
                      (change)="onChangeSelectedBranch($event)"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectABranch" | translate }}
                      </option>
                      <option
                        *ngFor="let branch of organizationBranchList"
                        [value]="branch.id"
                      >
                        {{ branch.name }}
                      </option>
                    </select>
                    <label for="inputBranch">{{ "branch" | translate }}</label>
                    <div
                      *ngIf="isControlInvalid('branchCode')"
                      class="text-danger"
                    >
                      {{ "branchIsRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Name -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      id="inputName"
                      [placeholder]="'name' | translate"
                      required
                    />
                    <label for="inputName">{{ "name" | translate }}</label>
                    <div *ngIf="isControlInvalid('name')" class="text-danger">
                      <ng-container
                        *ngIf="userForm.get('name').hasError('required')"
                      >
                        {{ "nameIsRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="userForm.get('name').hasError('pattern')"
                      >
                        {{ "onlyLatinCharacters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Surname -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="surname"
                      type="text"
                      class="form-control"
                      id="inputSurname"
                      [placeholder]="'surname' | translate"
                    />
                    <label for="inputSurname">{{
                      "surname" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('surname')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="userForm.get('surname').hasError('required')"
                      >
                        {{ "surnameIsRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="userForm.get('surname').hasError('pattern')"
                      >
                        {{ "onlyLatinCharacters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- PID -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="pid"
                      type="text"
                      class="form-control"
                      id="inputPid"
                      [placeholder]="'dermNo' | translate"
                    />
                    <label for="inputPid">{{ "dermNo" | translate }}</label>
                    <div *ngIf="isControlInvalid('pid')" class="text-danger">
                      <div *ngIf="userForm.get('pid')?.errors?.['required']">
                        {{ "PIDIsRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('pid')?.errors?.['minlength']">
                        {{ "PIDMustBeAtLeast6CharactersLong" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Date of Birth -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="dateOfBirth"
                      type="text"
                      class="form-control"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      bsDatepicker
                      appDateFormat
                      placeholder="dd-mm-yyyy"
                      maxlength="10"
                      #dp="bsDatepicker"
                      [bsConfig]="{
                        isAnimated: true,
                        dateInputFormat: 'DD-MM-YYYY',
                        maxDate: maxDate,
                        containerClass: 'theme-orange custom-datepicker'
                      }"
                    />
                    <label for="inputDob">{{
                      "dateOfBirth" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('dateOfBirth')"
                      class="text-danger"
                    >
                      {{ "dateOfBirthIsRequired" | translate }}
                    </div>
                  </div>
                </div>

                <!-- Phone Number -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="phoneNumber"
                      type="tel"
                      class="form-control"
                      id="inputTel"
                      [placeholder]="'phoneNumber' | translate"
                      (keypress)="allowOnlyNumbers($event)"
                      [pattern]="phoneNumberPattern"
                      maxlength="15"
                    />
                    <label for="inputTel">{{
                      "phoneNumber" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('phoneNumber')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['required']"
                      >
                        {{ "phoneNumberIsRequired" | translate }}
                      </div>
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['pattern']"
                      >
                        {{ "phoneNumberIsNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="email"
                      type="email"
                      class="form-control"
                      id="inputEmail"
                      [placeholder]="'email' | translate"
                    />
                    <label for="inputEmail">{{ "email" | translate }}</label>
                    <div *ngIf="isControlInvalid('email')" class="text-danger">
                      <div *ngIf="userForm.get('email')?.errors?.['required']">
                        {{ "emailIsRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('email')?.errors?.['email']">
                        {{ "emailIsNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/user/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
